export const getToday = (format?: string) => {
  const today = new Date();

  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');

  switch (format) {
    case 'yyyy년 mm월 dd일':
      return `${year}년 ${parseInt(month)}월 ${parseInt(day)}일`;
    default:
      return `${year}.${month}.${day}`;
  }
};

export const getTodayDateType = (data: string) => {
  const [year, month, day] = data.split('.');
  const date = new Date(Number(year), Number(month) - 1, Number(day));

  return date;
};

export const getTodayYear = () => {
  const today = new Date();
  const year = today.getFullYear();

  return year;
};

export const getTodayMonth = () => {
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, '0');

  return month;
};

export const getTodayDate = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');

  return day;
};

export const isDateBeforeToday = (dateString: string) => {
  const today = new Date();

  const year = parseInt(dateString.substring(0, 4));
  const month = parseInt(dateString.substring(4, 6)) - 1;
  const day = parseInt(dateString.substring(6, 8)) + 1;

  const dateToCompare = new Date(year, month, day);

  return dateToCompare < today;
};

export const calculateAge = (birth: string) => {
  const year = Number(birth.substring(0, 4));
  const month = Number(birth.substring(4, 6)) - 1;
  const day = Number(birth.substring(6, 8));
  const birthDate = new Date(year, month, day);
  const currentDate = new Date();

  const hasHadBirthdayThisYear =
    birthDate.getMonth() < currentDate.getMonth() ||
    (birthDate.getMonth() === currentDate.getMonth() &&
      birthDate.getDate() <= currentDate.getDate());

  const age =
    currentDate.getFullYear() -
    birthDate.getFullYear() -
    (hasHadBirthdayThisYear ? 0 : 1);

  return age;
};
